<pf-content>
    @if (item(); as item) {
        @if (imageUrl() === undefined) {
            <div class="item-info__image">
                <nz-skeleton-element
                    nzType="image"
                    [nzActive]="true"
                    class="item-info__image-skeleton"></nz-skeleton-element>
            </div>
        } @else if (imageUrl(); as url) {
            <div class="item-info__image">
                <img [src]="url" [alt]="item.name" />
            </div>
        }

        <h3 class="item-info__name">{{ item.name }}</h3>

        <div class="item-info__codes">
            @if (item.code) {
                <pf-chip pfStatus="primary-light">{{ item.code }}</pf-chip>
            }
            @if (item.sku && item.sku !== item.code) {
                <pf-text type="description">SKU: {{ item.sku }}</pf-text>
            }
            @if (item.hazardous) {
                <pf-chip pfStatus="danger">Hazardous</pf-chip>
            }
        </div>

        <dl class="item-info__facts">
            <div class="item-info__fact">
                <dt>UoM</dt>
                <dd>{{ uom() }}</dd>
            </div>
            @if (dimensions(); as dims) {
                <div class="item-info__fact">
                    <dt>Dimensions</dt>
                    <dd>{{ dims }}</dd>
                </div>
            }
            @if (weight(); as w) {
                <div class="item-info__fact">
                    <dt>Weight</dt>
                    <dd>{{ w }}</dd>
                </div>
            }
        </dl>

        @if (item.description) {
            <p class="item-info__description">{{ item.description }}</p>
        }
    } @else {
        <div class="item-info__image">
            <nz-skeleton-element
                nzType="image"
                [nzActive]="true"
                class="item-info__image-skeleton"></nz-skeleton-element>
        </div>
        <nz-skeleton
            [nzActive]="true"
            [nzTitle]="true"
            [nzParagraph]="{ rows: 4 }"></nz-skeleton>
    }
</pf-content>
